import React, { useRef, useEffect, ReactNode, useCallback } from "react";
import { Image } from "react-bootstrap";
import "./collapsible.scss";

type CollapsibleProps = {
  children: ReactNode;
  classNameContainer?: string;
  classNameButtonContainer?: string;
  classNameChildren?: string;
  buttonText: string;
  imageProps?: {
    height?: string;
    width?: string;
    src: string;
    alt: string;
  };
  isOpen: boolean;
  setIsOpen: React.Dispatch<boolean>;
  onToggle: () => void;
};

const Collapsible = ({
  children,
  classNameContainer,
  classNameChildren,
  classNameButtonContainer = "buttonContainer",
  buttonText,
  imageProps,
  isOpen,
  setIsOpen,
  onToggle,
}: CollapsibleProps) => {
  const collapsibleRef = useRef(null);

  const toggleOpen = () => {
    if (onToggle) {
      onToggle();
    }
  };

  const handleOutsideClick = useCallback(
    (event: MouseEvent) => {
      const clicked = event.target as HTMLElement;
      const clickedParent = (event.target as Node).parentElement as HTMLElement;
      if (
        collapsibleRef?.current &&
        !collapsibleRef?.current.contains(event.target as Node) &&
        // if we clicked from outside but on edit button we dont want to close
        !(
          clickedParent.classList.contains("editFilter") ||
          clicked.classList.contains("editFilter")
        )
      ) {
        setIsOpen(false);
      }
    },
    [setIsOpen]
  );

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("click", handleOutsideClick);
    } else {
      document.removeEventListener("click", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [handleOutsideClick, isOpen]);

  return (
    <div
      ref={collapsibleRef}
      className={`ToggleButton ${classNameContainer || ""}`}
    >
      <button
        type="button"
        onClick={toggleOpen}
        className={`button ${classNameButtonContainer}`}
      >
        {buttonText}
        <Image {...imageProps} />
      </button>

      <div
        className={`ToggleButton__content ${
          isOpen ? "ToggleButton__content--visible" : ""
        }`}
      >
        <div className={classNameChildren}>{children}</div>
      </div>
    </div>
  );
};

export default Collapsible;
